import { useState } from "react";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

interface ApproveOrDeclineArgs {
  studentEid: string | number;
  corporateId: number;
  objectId: number;
  editionId?: number;
  approve: boolean;
}

export const useApproveOrDeclineEnrollment = () => {
  const [isMutating, setIsMutating] = useState(false);

  const submit = async ({
    studentEid,
    corporateId,
    objectId,
    editionId,
    approve,
  }: ApproveOrDeclineArgs) => {
    setIsMutating(true);
    try {
      await fetcher<any>("/enrollment/approveOrDecline", MethodType.PATCH, {
        studentEid,
        enrollDate: new Date().toISOString(),
        approve: approve ? "Y" : "N",
        learningObject: {
          corporate_id: corporateId,
          object_id: objectId,
          edition_id: editionId,
        },
      });
    } finally {
      setIsMutating(false);
    }
  };

  return { submit, isMutating };
};
